// import KnowledgeCenter from "../components/KnowledgeCenter";
// import MediaSection from "../components/MediaSection";
// import EventsSection from "../components/EventsSection";
// import SocialMedia from "../components/SocialMedia";
// import Footer from "../components/Footer";
// import Highlighting from '../components/Highlighting';
// import PillarsBar from '../components/PillarsBar';
// import StickySocial from '../components/StickySocial';
// import KnowledgeInitiative from '../components/KnowledgeInitiative';
// import BecomeMember from '../components/BecomeMember';
// import Updates from '../components/Updates';
// import EventAndPodcast from '../components/EventAndPodcast';
// import GrowthPillars from '../components/GrowthPillars';
// import FlagshipAndEvent from '../components/FlagshipAndEvent';
// import Hero from '../components/HeroSection';

// const Home = () => {
//   return (
//     <div className="min-h-screen bg-white">
//       <main>
//         <Hero />
//         <GrowthPillars />
//         <FlagshipAndEvent />
//         <KnowledgeInitiative /> 
//         <BecomeMember />
//         <MediaSection />
//         <StickySocial />
//         <Updates /> 
//       </main>
//     </div>
//   );
// };

// export default Home;





// new new code 




import KnowledgeCenter from "../components/KnowledgeCenter";
import MediaSection from "../components/MediaSection";
import EventsSection from "../components/EventsSection";
import SocialMedia from "../components/SocialMedia";
import Footer from "../components/Footer";
import Highlighting from "../components/Highlighting";
import PillarsBar from "../components/PillarsBar";
import StickySocial from "../components/StickySocial";
import KnowledgeInitiative from "../components/KnowledgeInitiative";
import BecomeMember from "../components/BecomeMember";
import Updates from "../components/Updates";
import EventAndPodcast from "../components/EventAndPodcast";
import GrowthPillars from "../components/GrowthPillars";
import FlagshipAndEvent from "../components/FlagshipAndEvent";
import Hero from "../components/HeroSection";

// 👇 import the wrapper
import AnimatedSection from "./AnimatedSection";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <main>
        {/* Hero – you might want a different animation for the hero */}
        <AnimatedSection delay={0}>
          <Hero />
        </AnimatedSection>

        <AnimatedSection delay={0.1}>
          <GrowthPillars />
        </AnimatedSection>

        <AnimatedSection delay={0.2}>
          <FlagshipAndEvent />
        </AnimatedSection>

        <AnimatedSection delay={0.3}>
          <KnowledgeInitiative />
        </AnimatedSection>

        <AnimatedSection delay={0.4}>
          <BecomeMember />
        </AnimatedSection>

        <AnimatedSection delay={0.5}>
          <MediaSection />
        </AnimatedSection>

        {/* StickySocial might be fixed; you may not want to animate it, but you can if you like */}
        <AnimatedSection delay={0.6}>
          <StickySocial />
        </AnimatedSection>

        <AnimatedSection delay={0.7}>
          <Updates />
        </AnimatedSection>
      </main>
    </div>
  );
};

export default Home;